import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bnk-partner',
  templateUrl: './bnk-partner.component.html',
  styleUrls: ['./bnk-partner.component.scss']
})
export class BnkPartnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
